import React from "react";

const MapDirectionsBox = ({ legs = {} }) => {
  const steps = legs?.steps || 0;
  if (!steps.length) return null;
  return (
    <div
      style={{
        position: "",
        bottom: 12,
        left: 12,
        zIndex: 20,
        maxHeight: 360,
        overflow: "auto",
        background: "white",
        borderRadius: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
        padding: 10,
      }}
    >
      <div className="bold f12 my-1">Distance : {legs.distance.text}</div>
      <hr />
      <div className="bold f12 my-1">Durée : {legs.duration.text}</div>
      <hr />
      <div className="bold">Étapes : </div>
      <ol style={{ paddingLeft: 18, margin: 0 }}>
        {steps.map((s, i) => (
          <li
            key={i}
            style={{ marginBottom: 8, fontSize: 13, lineHeight: 1.35 }}
          >
            <div dangerouslySetInnerHTML={{ __html: s.instructions || "" }} />
            <div style={{ opacity: 0.7, fontSize: 12 }}>
              {s.distance?.text} • {s.duration?.text}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default MapDirectionsBox;
